export const CUSTOMER_SAVE_REQUIRED_HINT =
  'Для сохранения анкеты необходимо заполнить следующие поля: ФИО, Email, Телефон, Серия и номер паспорта';

export const REQUIRED_FIELD_HINT = (fieldLabel: string) => `Заполните поле "${fieldLabel}"`;
